import React from 'react';
import HsButton from '../../_common/hs-button/hs-button';
import { navigate } from 'gatsby';
import { MiniFaqStoryblok } from '../../../_shared/interfaces/storyblok';
import { getRichTextMarkup, StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as HomeMiniFaqStylesHs from './mini-faq.hs.module.scss';
import * as HomeMiniFaqStylesDr from './mini-faq.dr.module.scss';
import { getMultilinkURL } from '../../../lib/helpers/helpers';

const HomeMiniFaq = ({ blok, storyblokCommon }: { blok: MiniFaqStoryblok; storyblokCommon: StoryblokCommon }) => {
    const HomeMiniFaqStyles = storyblokCommon.configuration.content.theme === 'dr' ? HomeMiniFaqStylesDr : HomeMiniFaqStylesHs;

    return (
        <div className={HomeMiniFaqStyles.homeMiniFaq}>
            <div className={HomeMiniFaqStyles.header}>
                <h2>{blok.Headline}</h2>
            </div>

            <ul className={HomeMiniFaqStyles.questions}>
                {blok.Questions.map((question: any) => {
                    return (
                        <li key={question._uid}>
                            <h4>{question.Question}</h4>
                            <>
                                {typeof question.Answer === 'string' ? (
                                    <p>{question.Answer}</p>
                                ) : (
                                    <div dangerouslySetInnerHTML={getRichTextMarkup(question.Answer)} />
                                )}
                            </>
                        </li>
                    );
                })}
            </ul>

            <div className={HomeMiniFaqStyles.buttonWrapper}>
                <HsButton onClick={() => navigate(getMultilinkURL(blok.Button_Link))} storyblokCommon={storyblokCommon}>
                    {blok.Button}
                </HsButton>
            </div>
        </div>
    );
};

export default HomeMiniFaq;
